export const personalInfo = {
  name: "Amritpreet Singh",
  title: "Full-Stack Developer",
  tagline: "PHP • WordPress • AI • SEO • AWS",
  shortIntro:
    "Full-Stack Web Developer with 5+ years of experience building scalable, high-performance web applications using PHP, WordPress, Laravel, APIs, and cloud technologies.",
  email: "amrit.sembhi001@gmail.com",
  phone: "+971508294905",
  location: "Al Karama, Dubai, UAE",
  linkedin: "https://linkedin.com/in/amritpreet-singh-563464235",
  github: "#",
  twitter: "#",
  resumeLink: "/resume.pdf", // Place your resume PDF in the public folder
};

export const aboutSummary = `I am a results-driven Full-Stack Developer with over five years of hands-on experience delivering scalable, high-performance web applications across diverse industries. My core expertise spans PHP frameworks — Laravel, CodeIgniter, and CakePHP — alongside deep proficiency in WordPress ecosystem development including custom themes, plugins, WooCommerce, and advanced SEO optimization.

I specialize in building business-critical systems: from broker review platforms and real-time trading dashboards to AI-powered content workflows and payment gateway integrations. My work consistently focuses on measurable outcomes — faster load times, better search rankings, cleaner codebases, and architectures that scale.

On the modern stack, I bring working knowledge of React.js, Next.js, and Node.js, and I'm experienced in cloud deployment with AWS (EC2, S3), server configuration, and DevOps fundamentals. I thrive at the intersection of backend reliability and frontend polish, and I'm passionate about integrating AI and automation to deliver smarter, more efficient solutions.`;

export const aboutHighlights = [
  {
    icon: "experience",
    title: "5+ Years Experience",
    description:
      "Building production-grade web applications for clients across multiple industries.",
  },
  {
    icon: "performance",
    title: "Performance & SEO",
    description:
      "Proven track record of improving Core Web Vitals and reducing load times by 30–40%.",
  },
  {
    icon: "ai",
    title: "AI/API Integrations",
    description:
      "Integrating OpenAI, LLM APIs, and third-party services for intelligent automation.",
  },
  {
    icon: "wordpress",
    title: "WordPress & Laravel",
    description:
      "Deep expertise in custom plugin development, theme engineering, and Laravel backends.",
  },
  {
    icon: "cloud",
    title: "AWS Deployment",
    description:
      "Experienced with EC2, S3, SSL configuration, and scalable cloud hosting setups.",
  },
  {
    icon: "scalable",
    title: "Scalable Solutions",
    description:
      "Designing systems that grow with business needs — modular, maintainable, and reliable.",
  },
];

export const metrics = [
  { value: "5+", label: "Years Experience", suffix: "" },
  { value: "30-40%", label: "Performance Improvement", suffix: "" },
  { value: "50+", label: "Client Projects Delivered", suffix: "" },
  { value: "100%", label: "AI/API Integration Expertise", suffix: "" },
];
